import { render, staticRenderFns } from "./SafeSetting.vue?vue&type=template&id=a55ea53c&scoped=true"
import script from "./SafeSetting.vue?vue&type=script&lang=js"
export * from "./SafeSetting.vue?vue&type=script&lang=js"
import style0 from "./SafeSetting.vue?vue&type=style&index=0&id=a55ea53c&prod&scoped=true&lang=css"
import style1 from "./SafeSetting.vue?vue&type=style&index=1&id=a55ea53c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a55ea53c",
  null
  
)

export default component.exports